export default __webpack_public_path__ + "static/media/dashboardmenu.69008160.svg";